
'use strict';
define([
    'angular',
    'modules/settings/billingInfo/billingInfo.controller'
],function(angular,BillingInfoCtrl){
    var app=angular.module('settings.billingInfo', []);
    app.controller('BillingInfoCtrl',BillingInfoCtrl);
    return app;
});